import { get } from "../lib/request";

export async function getCountries() {
  const data = await get("/countries");
  if (!data.success) {
    throw new Error(data.message);
  }
  return data.data;
}

export async function signup() {}
